import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

class PageHelmet extends Component {

  render() {
    const {homepageTitle, pageTitle} = this.props;
    return (
      <Helmet>
        <title>{`${homepageTitle ? homepageTitle : "Stag Planner"}${pageTitle ? (" | " + pageTitle) : ""}`}</title>
      </Helmet>
    );
  }

}

PageHelmet.propTypes = {
  homepageTitle: PropTypes.string,
  pageTitle: PropTypes.string,
};

export default PageHelmet;



// WEBPACK FOOTER //
// ./src/component/organisms/PageHelmet/component.js